export default {
  SET_EMPLOYERS: 'SET_EMPLOYERS',
  SET_CONTRACTORS: 'SET_CONTRACTORS',
  SET_ADMIN_ROLE: 'SET_ADMIN_ROLE',
  SET_AREA_MANAGER_ROLE: 'SET_AREA_MANAGER_ROLE',
  SET_INSIGHTS_ROLE: 'SET_INSIGHTS_ROLE',
  SET_CONTRACT_PROJECTS: 'SET_CONTRACT_PROJECTS',
  SET_CONTRACT_PACKAGES: 'SET_CONTRACT_PACKAGES',
  SET_CONTRACT_TYPES: 'SET_CONTRACT_TYPES',
  SET_WORKFLOWS: 'SET_WORKFLOWS',
  UPDATE_FLOW: 'UPDATE_FLOW',
  DELETE_FLOW: 'DELETE_FLOW',
  DELETE_FLOW_STEP: 'DELETE_FLOW_STEP',
  ADD_STEP_NAME: 'ADD_STEP_NAME',
  SET_STEPS_NAMES: 'SET_STEPS_NAMES',
  SET_NOTIFICATION_DAYS: 'SET_NOTIFICATION_DAYS',
  SET_WORKFLOWS_TYPES: 'SET_WORKFLOWS_TYPES',
  SET_CURRENCIES: 'SET_CURRENCIES',
  SET_VARIATIONS_STAGES: 'SET_VARIATIONS_STAGES',
  SET_STATUSES: 'SET_STATUSES',
  SET_CATEGORIES: 'SET_CATEGORIES',
  ADD_EMPLOYER: 'ADD_EMPLOYER',
  ADD_CONTRACTOR: 'ADD_CONTRACTOR',
  CREATE_MESSAGE: 'CREATE_MESSAGE',
  SET_APP_INIT: 'SET_APP_INIT',
  IS_FETCHING: 'IS_FETCHING',
  FETCHING_DONE: 'FETCHING_DONE',
  SET_CONTRACTS: 'SET_CONTRACTS',
  UPDATE_CONTRACT: 'UPDATE_CONTRACT',
  SET_WORKSTREAMS: 'SET_WORKSTREAMS',
  SET_ROOT_CAUSES: 'SET_ROOT_CAUSES',
  SET_AREAS: 'SET_AREAS',
  SET_RISKS: 'SET_RISKS',
  SET_CAN_USER_PERMISSIONS: 'SET_CAN_USER_PERMISSIONS',
  SET_LOCAL_USERS: 'SET_LOCAL_USERS',
  GUARANTEES_NAMES: 'GUARANTEES_NAMES'
}
